/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import React, { useEffect, useState, useCallback, createRef } from 'react';
import { Modcharts } from '@markit/modcharts';
import { useSelector } from 'react-redux';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import { get } from 'lodash';

import accessTokenService from 'services/accessTokenService';
import CustomXAxis from 'components/ChartXAxis/ChartXAxis';
import HiddenTable from 'components/HiddenTable/HiddenTable';
import { requestDailyPriceModChart } from '../../Actions/PriceChartActions';
import './DailyChart.scss';

const DailyModCharts = props => {
	const [chart, setChart] = useState(null);
	const { translate, xids, setLastUpdated } = props;

	const [chartRef, setChartRef] = useState(createRef());
	const [containerRef, setContainerRef] = useState(createRef());

	const chartUnavailableText = translate('chartUnavailable');

	let chartRoot;

	// callback for mutation observer (If chart unavailable => No x-axis)
	const processChartMutations = (mutations, observer) => {
		mutations.forEach(mutation => {
			const notAvailable = chartRoot.getElementsByClassName('modcharts-chartnotavailable');

			const chartContainer = containerRef.current;
			const footerElement = chartContainer.getElementsByClassName('custom-xaxis-container');

			// Show/Hide x-axis
			if (notAvailable && notAvailable.length > 0) {
				footerElement[0].style.display = 'none';
				notAvailable[0].classList.add('daily-chart-text');

				if (notAvailable[0].innerHTML !== chartUnavailableText) {
					notAvailable[0].innerHTML = chartUnavailableText;
				}
			} else {
				footerElement[0].style.display = 'flex';
			}
		});
	};

	// create an observer instance (We need to watch charts tree)
	const observer = new MutationObserver(processChartMutations);

	const chartData = useSelector(state => get(state, 'priceChartData.data', {}));

	const defaultChartHeight = 106;
	const defaultChartWidth = 260;
	const minChartWidth = 203;

	const label = translate('dailyChart');

	const venue = get(xids, 'venue');

	const initNewChart = useCallback(() => {
		const newChart = new Modcharts(chartRoot);

		const token = accessTokenService.retrieve();

		newChart.setAuthToken(token);

		const priceChart = requestDailyPriceModChart(venue);

		newChart.load(priceChart);

		setChart(newChart);
	}, []);

	const createChart = () => {
		chartRoot = chartRef.current;

		if (chartRoot) {
			// start observing target element (Watching charts tree)
			observer.observe(chartRoot, { childList: true, subtree: true });

			if (!chart) {
				initNewChart();
			}
		}
	};

	const setChartLastUpdated = () => {
		const options = {
			timeZone: 'America/New_York',
			timeZoneName: 'short',
			hour: '2-digit',
			year: 'numeric',
			day: '2-digit',
			month: 'short',
			minute: '2-digit'
		};
		const dateTime = new Date().toLocaleTimeString('en-us', options);

		setLastUpdated(dateTime);
	};

	useEffect(() => {
		createChart();
	}, [chart, initNewChart]);

	useEffect(() => {
		if (chart) {
			const priceChart = requestDailyPriceModChart(venue);
			chart.load(priceChart);
		}
	}, [xids]);

	setChartLastUpdated();

	const hiddenTable = chart
		? (
			<HiddenTable
				settings={[
					{
						label: translate('date'),
						formatFunc: 'timeWithTimezone',
						isMsDate: true,
						dataPoint: 'Date'
					},
					{
						label: translate('value'),
						formatFunc: 'price',
						dataPoint: 'Value'
					}
				]}
				tableData={chartData.hoverData}
				caption={label} />
		) : null;


	return (
		<div style={{ flexGrow: 1, maxWidth: defaultChartWidth, minWidth: minChartWidth }} className="daily-chart" ref={containerRef}>
			<div style={{ display: chart ? 'block' : 'none' }}>
				<div className="daily-chart-title">{translate('dailyChart')}</div>
				<div id="chart-dom-element" className="chart-element" style={{ height: defaultChartHeight, marginTop: 10 }} ref={chartRef} />
				{<CustomXAxis />}
				{hiddenTable}
			</div>
			{ !chart && (
				<div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<span className="daily-chart-text">
						{chartUnavailableText}
					</span>
				</div>
			)}
		</div>
	);
};
export default withTranslate(DailyModCharts);
